<template>
  <BaseLineChart :data="data" :options="options" />
</template>

<script lang="ts">
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line as BaseLineChart } from "vue-chartjs";
import { defineComponent, type PropType } from "vue";
import type { Scale } from "chart.js";
import { type ChartOptions, type ChartData } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip);

export const defaultLineChartOptions: ChartOptions<"line"> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false,
  },
  plugins: {
    legend: {
      display: true,
      position: "bottom" as const,
      align: "start" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "line",
        pointStyleWidth: 15,
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        // showing not all labels on x axis, but one in the beginning, middle and end
        callback: function (this: Scale, value: string | number, index: number) {
          const total = this.ticks.length;

          const isFirst = index === 0;
          const isMiddle = index === Math.floor(total / 2);
          const isLast = index === total - 1;

          if (isFirst || isMiddle || isLast) {
            return this.getLabelForValue(value as number);
          }

          return "";
        },
      },
    },
    y: {
      min: 0,
      beginAtZero: true,
      grid: {
        display: true,
      },
    },
  },
};

export default defineComponent({
  components: {
    BaseLineChart,
  },
  props: {
    data: {
      type: Object as PropType<ChartData<"line">>,
      required: true,
    },
    options: {
      type: Object as PropType<ChartOptions<"line">>,
      default: () => {
        return defaultLineChartOptions;
      },
    },
  },
});
</script>
